import { Injectable } from '@angular/core';
import { WindowRefService, localStorageEnabled } from '@callrail/looky/util';
import { ReplaySubject } from 'rxjs';

import * as FullStory from '@fullstory/browser';

@Injectable({
  providedIn: 'root',
})
export class FullstoryService {
  private fsInitializedObs = new ReplaySubject<boolean>(1);
  public fsInitialized$ = this.fsInitializedObs.asObservable();

  constructor(windowRef: WindowRefService) {
    /* eslint-disable no-underscore-dangle */
    const nativeWindow = windowRef.nativeWindow();
    const oldFn = nativeWindow._fs_ready;
    nativeWindow._fs_is_outer_script = windowRef.inIframe();
    nativeWindow._fs_ready = () => {
      if (oldFn) {
        oldFn();
      }
      this.fsInitializedObs.next(true);
    };
    /* eslint-enable no-underscore-dangle */
  }

  public get fs(): any {
    return FullStory;
  }

  public isEventLogEnabled(): boolean {
    return (
      localStorageEnabled() &&
      localStorage.getItem('fullstory_console_event_log') === 'true'
    );
  }

  public setEventLogEnabled(enabled: boolean): void {
    if (!localStorageEnabled()) {
      return;
    }
    if (enabled) {
      localStorage.setItem('fullstory_console_event_log', 'true');
    } else {
      localStorage.removeItem('fullstory_console_event_log');
    }
  }

  public addCustomEvent(eventName: string, eventParams: object): void {
    const initialized = FullStory.isInitialized();

    if (this.isEventLogEnabled()) {
      // Each %c consumes one style argument, and an empty style resets the
      // preceding one so the pills don't bleed into the text after them.
      const pill = 'border-radius: 3px; padding: 2px 6px; font-weight: bold;';
      let format = '%cFullStory Event%c %c' + eventName + '%c';
      const styles = [
        `${pill} background: #4a4a4a; color: #fff;`,
        '',
        `${pill} background: #f0b429; color: #3d2b00;`,
        '',
      ];

      if (!initialized) {
        format += '\n%c⚠️ Not sent — FullStory is not initialized';
        styles.push('font-weight: bold; color: #e53935;');
      }

      // Writing to the console is the entire point of this branch.
      // eslint-disable-next-line no-console
      console.log(format, ...styles, eventParams);
    }

    if (initialized) {
      FullStory.event(eventName, eventParams);
    }
  }
}
